import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AdminLayout } from './layouts/AdminLayout';
// Placeholder components for pages we haven't built yet
const PlaceholderPage = ({
  title
}: {
  title: string;
}) => <div className="space-y-6" data-id="element-0">
    <h1 className="text-2xl font-bold text-slate-900" data-id="element-1">{title}</h1>
    <div className="p-12 border-2 border-dashed border-slate-300 rounded-lg text-center text-slate-500" data-id="element-2">
      Page content for {title} coming soon
    </div>
  </div>;
// We will replace these imports with real page components as we build them
import { ManageCourses } from './pages/ManageCourses';
import { SectionQuestions } from './pages/SectionQuestions';
import { EditSectionQuestion } from './pages/EditSectionQuestion';
import { SearchUser } from './pages/SearchUser';
import { EditUser } from './pages/EditUser';
import { OrderSearch } from './pages/OrderSearch';
import { PrintOrder } from './pages/PrintOrder';
import { AdminArea } from './pages/AdminArea';
import { Dashboard } from './pages/Dashboard';
import { ModifyProfile } from './pages/ModifyProfile';
import { StaticPages } from './pages/StaticPages';
import { EmailDetails } from './pages/EmailDetails';
import { EditProfileCustomFields } from './pages/EditProfileCustomFields';
import { EditEmailNotifications } from './pages/EditEmailNotifications';
import { EditDirectionText } from './pages/EditDirectionText';
import { CreditTypes } from './pages/CreditTypes';
import { EditCreditType } from './pages/EditCreditType';
import { ManagePackages } from './pages/ManagePackages';
import { EditPackage } from './pages/EditPackage';
import { ManageCoupons } from './pages/ManageCoupons';
import { EditCoupon } from './pages/EditCoupon';
export function App() {
  return <Router data-id="element-3">
      <Routes data-id="element-4">
        {/* Print Order is a standalone page without the admin shell */}
        <Route path="/custom/orders/print_order/:orderId" element={<PrintOrder data-id="element-6" />} data-id="element-5" />

        {/* All other routes are wrapped in AdminLayout */}
        <Route path="/*" element={<AdminLayout data-id="element-8">
              <Routes data-id="element-9">
                <Route path="/" element={<Dashboard data-id="element-11" />} data-id="element-10" />

                {/* Course Admin */}
                <Route path="/courses" element={<ManageCourses data-id="element-13" />} data-id="element-12" />
                <Route path="/sections" element={<PlaceholderPage title="Course Sections" data-id="element-15" />} data-id="element-14" />
                <Route path="/export-course" element={<PlaceholderPage title="Export Course" data-id="element-17" />} data-id="element-16" />
                <Route path="/export-users" element={<PlaceholderPage title="Export Users" data-id="element-19" />} data-id="element-18" />
                <Route path="/questions" element={<SectionQuestions data-id="element-21" />} data-id="element-20" />
                <Route path="/questions/edit/:id" element={<EditSectionQuestion data-id="element-23" />} data-id="element-22" />
                <Route path="/questions/add" element={<EditSectionQuestion data-id="element-25" />} data-id="element-24" />

                {/* Management */}
                <Route path="/users" element={<SearchUser data-id="element-27" />} data-id="element-26" />
                <Route path="/users/edit/:id" element={<EditUser data-id="element-29" />} data-id="element-28" />
                <Route path="/orders" element={<OrderSearch data-id="element-31" />} data-id="element-30" />
                <Route path="/admin-area" element={<AdminArea data-id="element-33" />} data-id="element-32" />

                {/* Admin Area Sub-pages */}
                <Route path="/static-pages" element={<StaticPages data-id="element-35" />} data-id="element-34" />
                <Route path="/email-details" element={<EmailDetails data-id="element-37" />} data-id="element-36" />
                <Route path="/custom-fields" element={<EditProfileCustomFields data-id="element-39" />} data-id="element-38" />
                <Route path="/notifications" element={<EditEmailNotifications data-id="element-41" />} data-id="element-40" />
                <Route path="/direction-text" element={<EditDirectionText data-id="element-43" />} data-id="element-42" />
                <Route path="/credit-types" element={<CreditTypes data-id="element-45" />} data-id="element-44" />
                <Route path="/credit-types/edit/:id" element={<EditCreditType data-id="element-47" />} data-id="element-46" />
                <Route path="/credit-types/add" element={<EditCreditType data-id="element-49" />} data-id="element-48" />

                {/* Packages */}
                <Route path="/packages" element={<ManagePackages data-id="element-51" />} data-id="element-50" />
                <Route path="/packages/edit/:id" element={<EditPackage data-id="element-53" />} data-id="element-52" />
                <Route path="/packages/add" element={<EditPackage data-id="element-55" />} data-id="element-54" />
                <Route path="/coupons" element={<ManageCoupons data-id="element-57" />} data-id="element-56" />
                <Route path="/coupons/edit/:id" element={<EditCoupon data-id="element-59" />} data-id="element-58" />
                <Route path="/coupons/add" element={<EditCoupon data-id="element-61" />} data-id="element-60" />
                <Route path="/profile" element={<ModifyProfile data-id="element-63" />} data-id="element-62" />
              </Routes>
            </AdminLayout>} data-id="element-7" />
      </Routes>
    </Router>;
}